import Emitter from 'pico-emitter';

const eventBus = (app) => {
  app.config.globalProperties.$eventBus = new Emitter()
  return app
}

export {
  eventBus
}
